<div class="project-info-meta-list">
  <div *ngFor="let meta of leadMetaKeys" class="project-info-meta-item">
    <label>{{ meta.name }}</label>
    <div class="value">{{ meta.metaValues[0]?.value ?? '-' }}</div>
  </div>
</div>
